import React from 'react'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import {
  TooltipButton,
  type TooltipButtonProps,
} from '~/components/elements/TooltipButton'
import { Typography } from '~/components/elements/Typography'
import { useCopyToClipboard } from '~/hooks/useCopyToClipboard'

import { type BrandAccount } from '../hooks/useMainQuery'

export type NameCellProps = {
  dataItem: BrandAccount
}

export const IdCell = ({ dataItem: brandAccount }: NameCellProps) => {
  const { t } = useTranslation()
  const copyToClipboard = useCopyToClipboard()
  const handleCopyButtonClick = React.useCallback<
    EH<TooltipButtonProps, 'onClick'>
  >(() => {
    copyToClipboard(brandAccount.id, {
      notificationText: t('brandaccount_name_id_copied', {
        brandAccount,
      }),
    })
  }, [brandAccount, copyToClipboard, t])

  return (
    <td>
      <HStack
        align="center"
        backgroundColor="transparent"
        justify="space-between"
        spacing={2}
      >
        <Typography fontSize={14} variant="normal">
          {brandAccount.id}
        </Typography>

        <TooltipButton
          fillMode="flat"
          icon="copy"
          title="Copy"
          onClick={handleCopyButtonClick}
        />
      </HStack>
    </td>
  )
}
